export const EVENTS = {
  QUESTION_VIEWED: "question viewed",
  QUESTION_ANSWERED: "updated answer",
  BEGIN_PROCESS: "start flow"
}

export const track = (event, payload) => {
  window.analytics.track(event, payload)
}

export const identify = (accountId, payload) => {
  window.analytics.identify(accountId, payload)
}

export const alias = id => window.analytics.alias(id)

export const getUserLanguage = () => {
  const lang =
    window.localStorage.currentLocale ||
    (window.navigator && window.navigator.language && window.navigator.language)
  return (lang && lang.split("-")[0]) || "en"
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js